import React from 'react';

import { Text } from '@chakra-ui/react';

interface TypographicProps {
  color?: React.CSSProperties['color'];
  fontSize?: React.CSSProperties['fontSize'];
  fontWeight?: React.CSSProperties['fontWeight'];
  fontFamily?: React.CSSProperties['fontFamily'];
  lineHeight?: React.CSSProperties['lineHeight'];
  textAlign?: React.CSSProperties['textAlign'];
  textTransform?: React.CSSProperties['textTransform'];
  letterSpacing?: React.CSSProperties['letterSpacing'];
  textDecoration?: React.CSSProperties['textDecoration'];
  style?: React.CSSProperties;
  sx?: React.CSSProperties;
  children?: React.ReactNode;
}

const NoWrap = ({
  color = 'inherit',
  fontSize = 'inherit',
  fontWeight = 'inherit',
  fontFamily = 'inherit',
  lineHeight = 'inherit',
  textAlign = 'inherit',
  textTransform = 'inherit',
  letterSpacing = 'inherit',
  textDecoration = 'inherit',
  style,
  sx,
  children,
  ...restProps
}: TypographicProps) => {
  const noWrapStyles: React.CSSProperties = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  const mergedStyles: React.CSSProperties = {
    ...noWrapStyles,
    color,
    fontSize,
    fontWeight,
    fontFamily,
    lineHeight,
    textAlign,
    textTransform,
    letterSpacing,
    textDecoration,
    ...style
  };

  const mergedSx = {
    ...noWrapStyles,
    color,
    fontSize,
    fontWeight,
    fontFamily,
    lineHeight,
    textAlign,
    textTransform,
    letterSpacing,
    textDecoration,
    ...sx
  };

  return (
    <Text as='span' style={mergedStyles} sx={mergedSx} {...restProps}>
      {children}
    </Text>
  );
};

NoWrap.displayName = 'NoWrap';

export default NoWrap;
